export const SET_AUTH_STATE = 'SET_AUTH_STATE';
export const SET_DEFAULT_SITE = 'SET_DEFAULT_SITE';
export const AUTHORISE_EMPLOYEE = 'AUTHORISE_EMPLOYEE';
export const SET_USER = 'SET_USER';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_DISPATCHER_TOKEN = 'SET_DISPATCHER_TOKEN';
export const UNAUTHORISE_EMPLOYEE = 'UNAUTHORISE_EMPLOYEE';
